export const numberToCurrencyString = (
  value: number | null | undefined,
  locale?: string | string[] | undefined,
  options?: Intl.NumberFormatOptions | undefined
): string => {
  // Data Platform draft orders carry null prices until Place order; show the
  // same '--' the orders list and checkout summary use for a missing amount.
  if (value === null || value === undefined) {
    return '--'
  }
  locale = locale || (typeof global !== 'undefined' ? 'en-EN' : undefined)
  return value.toLocaleString(locale, options)
}
